/**
 * Capacities & Resources Overview
 *
 * Main landing page with tabs for:
 * - Physical Inventory: Existing warehouse dashboard (inline)
 * - Cloud Resources: Cloud infrastructure capacity dashboard
 */

import SubHeaders from '@/components/Headers/SubHeaders'
import { paths } from '@/utils/path'
import useTabs from '@/hooks/useTabs'
import { Tabs } from 'vnetwork-ui'
import { Cloud, Warehouse } from 'lucide-react'
import WarehouseDashboard from '../Dashboard'
import CloudCapacityDashboard from '../CloudCapacity'

const CapacitiesOverview = () => {
    // Setup tabs - TabComponent renders content inline
    const { TabProps, TabComponent } = useTabs({
        tabs: [
            {
                label: 'Physical Inventory',
                value: 'inventory',
                startIcon: <Warehouse className="h-4 w-4" />,
                // Render full WarehouseDashboard inline (without SubHeaders since we have our own)
                component: <InventoryContent />,
            },
            {
                label: 'Cloud Resources',
                value: 'cloud',
                startIcon: <Cloud className="h-4 w-4" />,
                // Render cloud capacity dashboard
                component: <CloudCapacityDashboard />,
            },
        ],
    })

    return (
        <div>
            <SubHeaders
                breadcrumbs={[
                    {
                        path: paths.warehouse,
                        title: 'Capacities & Resources',
                    },
                ]}
            />

            {/* Tabs container */}
            <div className="lg:flex lg:flex-wrap items-center gap-4 mb-2 mt-1 bg-white rounded-md justify-between">
                <div className="flex items-center gap-2">
                    <Tabs {...TabProps} tabContainerClassName="pt-0" />
                </div>
            </div>

            {/* Tab content */}
            {TabComponent}
        </div>
    )
}

/**
 * Inventory Content - renders the warehouse dashboard without duplicate headers
 */
const InventoryContent = () => {
    return <WarehouseDashboard hideHeader />
}

export default CapacitiesOverview
